import { useEffect, useState } from 'react';

// Supporting code for virtual scrolling
export function windowHeightResized(): null {
  // oxlint-disable-next-line react/rules-of-hooks -- this legacy hook wrapper name is intentionally unchanged
  const [windowHeight, setWindowHeight] = useState<number>(0);

  // oxlint-disable-next-line react/rules-of-hooks -- this legacy hook wrapper name is intentionally unchanged
  useEffect(() => {
    const handler = () => {
      setWindowHeight(windowHeight - windowHeight + window.innerHeight);
    };

    handler();

    window.addEventListener('resize', handler);

    return () => {
      window.removeEventListener('resize', handler);
    };
  }, []);

  return null;
}
